import AccountOrganizationsPage from '@/apps/account/views/Organizations';
import LoginPage from './views/Login';
import WelcomePage from './views/Welcome';

export const authPublicRoutes = [
  {
    path: '/',
    name: '登录',
    element: <LoginPage />,
  },
];

export const authProtectedRoutes = [
  {
    path: '/welcome',
    name: '暂无可用组织',
    element: <WelcomePage />,
  },
  {
    path: '/organizations',
    name: '组织管理',
    element: <AccountOrganizationsPage />,
  },
];

export const authLayoutRoutes = [...authPublicRoutes, ...authProtectedRoutes];
